import React, { useRef } from 'react'
import { Grow, Paper } from '@mui/material'
import { TypewriterText } from '@/shared/components/Typewriter/TypewriterText'
import { ANIMATION_DURATION, TRANSITION_DELAY } from '@/constants/register.contants'

export const WelcomeMessage: React.FC<WelcomeMessageProps> = ({ onAnimationComplete }) => {
  const animationCompleteRef = useRef(false)

  const handleEntered = () => {
    if (!animationCompleteRef.current) {
      animationCompleteRef.current = true
      setTimeout(onAnimationComplete, TRANSITION_DELAY)
    }
  }

  return (
    <Grow in={true} timeout={ANIMATION_DURATION} onEntered={handleEntered}>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mt: 3,
          mb: 1,
          borderRadius: 4,
          borderColor: 'divider',
          borderStyle: 'solid',
        }}
      >
        <TypewriterText
          variant="body1"
          delay={5}
          text="Hi there! 👋 Ready to drive change with the explorer today? Let's get you registered in just a few steps. "
        />
      </Paper>
    </Grow>
  )
}
